import React, { PureComponent } from 'react'
import { DatePicker } from 'antd-mobile';
import moment, { Moment } from 'moment';
import arrive from '../../assets/img/arrive.png';
import './time-picker.scss';
export interface ITimePickerState {
  timePickerVisible: boolean;
  startTimeText: string;
  endTimeText: string;
  startTime: Date;
  endTime: Date;
}

export default class TimePicker extends PureComponent<any, ITimePickerState> {

  openType: 'startTime' | 'endTime' = 'startTime';

  constructor(props: any) {
    super(props);
    this.state = {
      timePickerVisible: false,
      startTimeText: '',
      endTimeText: '',
      startTime: new Date(),
      endTime: new Date()
    };
  }

  componentDidMount() {
    if (this.props.startTime) {
      this.setTime().startTime(this.props.startTime);
    }
    if (this.props.endTime) {
      this.setTime().endTime(this.props.endTime);
    }
  }

  setTime() {
    return {
      endTime: (v: any | Moment) => {
        v = moment(v).endOf('year').format('YYYY/MM/DD HH:mm:ss')
        this.setState({
          endTime: moment(v).toDate(),
          endTimeText: moment(v).format('YYYY年'),
        });
      },
      startTime: (v: any | Moment) => {
        v = moment(v).startOf('year').format('YYYY/MM/DD HH:mm:ss')
        this.setState({
          startTime: moment(v).toDate(),
          startTimeText: moment(v).format('YYYY年')
        });
      }
    };
  }

  showDatePicker(type: 'startTime' | 'endTime') {
    this.openType = type;
    this.setState({
      timePickerVisible: true
    });
  }

  close = () => {
    this.setState({
      timePickerVisible: false
    });
  }

  timeValueChange(v: any) {
    if (this.openType === 'startTime') {
      v = moment(v).startOf('year').format('YYYY/MM/DD HH:mm:ss')
      this.setState({
        startTimeText: moment(v).startOf('year').format('YYYY年'),
        startTime: v
      });
      v = moment(v).endOf('year').format('YYYY/MM/DD HH:mm:ss')
      this.setState({
         endTimeText: moment(v).endOf('year').format('YYYY年'),
         endTime: v
      },()=> {this.callback()})
    }
   
  }

  callback = () => {
    if (this.props.onSearch) {
      this.props.onSearch(this.state);
    }
  }

  render() {
    return (
      <div className="timePicker2 timePicker">
        <div className="content">
          <div className="timeShow" onClick={this.showDatePicker.bind(this, 'startTime')}>
            <label className="timeValue">{this.state.startTimeText || "选择时间"}</label>
            <img src={arrive} alt="" className="downArrive"></img>
          </div>
        </div>
            <div>
                <DatePicker
                visible={this.state.timePickerVisible}
                onOk={this.close}
                title={this.openType === 'startTime'? '选择时间': '结束时间'}
                mode="year"
                onDismiss={() => this.close()}
                onChange={(v: Date) => this.timeValueChange(v)}
                ></DatePicker>
            </div> 
      </div>
    )
  }
}
